var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: "40px 50px" },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: [
                    "platform:system:config:seckill:style:get",
                    "platform:system:config:seckill:style:save",
                  ],
                  expression:
                    "['platform:system:config:seckill:style:get', 'platform:system:config:seckill:style:save']",
                },
              ],
              ref: "signForm",
              staticClass: "demo-ruleForm",
              attrs: { model: _vm.seckillStyleForm, "label-width": "90px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "秒杀样式：", prop: "value" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.seckillStyleForm.value,
                        callback: function ($$v) {
                          _vm.$set(_vm.seckillStyleForm, "value", $$v)
                        },
                        expression: "seckillStyleForm.value",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("样式1"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("样式2"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "样式展示：" } },
                [
                  _vm.seckillStyleForm.value === "1"
                    ? _c("el-image", {
                        staticClass: "image",
                        attrs: {
                          src: _vm.imgage1,
                          "preview-src-list": [_vm.imgage1],
                        },
                      })
                    : _c("el-image", {
                        staticClass: "image",
                        staticStyle: { height: "445px" },
                        attrs: {
                          src: _vm.imgage2,
                          "preview-src-list": [_vm.imgage2],
                        },
                      }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _vm.checkPermi(["platform:system:config:seckill:style:save"])
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.submitForm },
                        },
                        [_vm._v("提交")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }